import React from "react";
import {
  NormalButton,
  NormalInput,
  NormalSelect,
  SearchInputKeyboard,
} from "component/common";
import {
  getCustomerPlusSettings,
  updateCustomerPlusSettings,
} from "redux/actions/customerPlus";
import { InputSearch, TableWrapper } from "component/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export class SettingsClass extends React.Component {
  constructor(props) {
    super(props);
    this.childInputRef = React.createRef();
  }
  state = {
    dataList: [],
    originalData: [],
    tableHeader: [
      { label: "Field Name", sortKey: "display_field_name", width: 220 },
      {
        label: "Mandatory",
        sortKey: "mandatory",
        divClass: "justify-content-center",
      },
      {
        label: "Show in Register",
        sortKey: "visible_in_registration",
        divClass: "justify-content-center",
      },
      {
        label: "Show in Profile",
        sortKey: "visible_in_profile",
        divClass: "justify-content-center",
      },
      {
        label: "Show in Listing",
        sortKey: "visible_in_listing",
        divClass: "justify-content-center",
      },
      {
        label: "Show Label",
        sortKey: "showLabel",
        divClass: "justify-content-center",
      },
    ],
    isLoading: true,
    isMounted: true,
    searchInputValue: "",
  };

  componentWillUnmount() {
    this.state.isMounted = false;
  }

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  componentDidMount() {
    this.loadData();
  }
  // handleSerch
  // handleSearch = event => {
  //   let { originalData, dataList } = this.state;
  //   dataList = originalData.filter(
  //     e =>
  //       e.display_field_name
  //         .toLocaleLowerCase()
  //         .includes(event.target.value.toLocaleLowerCase()) ||
  //       e.field_name
  //         .toLocaleLowerCase()
  //         .includes(event.target.value.toLocaleLowerCase())
  //   );
  //   this.updateState({ dataList });
  // };

  // handleSearchInput
  handleSearchInput = (value) => {
    this.setState({ searchInputValue: value });
    let { originalData, dataList } = this.state;
    dataList = originalData.filter(
      (e) =>
        e.display_field_name
          .toLocaleLowerCase()
          .includes(value.toLocaleLowerCase()) ||
        e.field_name.toLocaleLowerCase().includes(value.toLocaleLowerCase())
    );
    this.updateState({ dataList });
  };

  loadData = async () => {
    this.updateState({ isLoading: true });
    await this.props.getCustomerPlusSettings();
    let { dataList } = this.props;
    this.updateState({ dataList, originalData: dataList, isLoading: false });
  };

  handleSubmit = async () => {
    this.updateState({ isLoading: true });
    let { dataList } = this.state;
    if (dataList.length == 0) return;
    let reqData = { customerControlList: dataList };
    await this.props.updateCustomerPlusSettings(JSON.stringify(reqData));
    this.loadData();
  };

  render() {
    let { dataList, tableHeader, isLoading, searchInputValue } = this.state;
    let { t } = this.props;
    return (
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
            <h3 className="head-label">{t("Customer Plus Settings")}</h3>
          </div>
        </div>

        <div className="row  mb-4">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="row rowGapBottom">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
                {this.props.tokenDetails.ipadkey ? (
                  <SearchInputKeyboard
                    onRef={(ref) => (this.childInputRef = ref)}
                    onChangeTextInput={(e) => this.handleSearchInput(e)}
                    focusValue={"searchPlusSetting"}
                    placeHolderText={"Search Field"}
                    isSearchIcon={false}
                    parentPassIntialValue={this.state.searchInputValue}
                  />
                ) : (
                  <div className="input-container d-flex align-items-center">
                    <NormalInput
                      placeholder="Search Field"
                      value={this.state.searchInputValue}
                      name="searchInputValue"
                      onChange={(e) => this.handleSearchInput(e.target.value)}
                      // onClick={this.handleClick}
                    />
                  </div>
                )}
              </div>

              <div className="col-7 col-sm-4 col-md-4 col-lg-4 col-xl-2">
                <Link to="/admin/customerplus/settings/layout">
                  <NormalButton mainbg={true} label="Edit Layout" />
                </Link>
              </div>
              <div className="col-5 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                <NormalButton
                  mainbg={true}
                  label="Save"
                  onClick={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <div className="table-container">
            <TableWrapper
              headerDetails={tableHeader}
              queryHandler={this.handlePagination}
              parentHeaderChange={(value) =>
                this.updateState(() => (tableHeader = value))
              }
              sortData={this.state.originalData}
              onSort={(list) => this.updateState({ dataList: list })}
            >
              {isLoading ? (
                <tr>
                  <td colSpan="7">
                    <div class="d-flex mt-5 align-items-center justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : dataList ? (
                dataList.map((item, index) => {
                  let {
                    display_field_name,
                    visible_in_profile,
                    visible_in_listing,
                    mandatory,
                    visible_in_registration,
                    showLabel,
                  } = item;
                  return (
                    <tr key={index}>
                      <td
                        className={
                          tableHeader[0].enabled ?? true ? "" : "d-none"
                        }
                      >
                        <div className="text-left">{display_field_name}</div>
                      </td>
                      <td
                        className={
                          tableHeader[3].enabled ?? true ? "" : "d-none"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={mandatory}
                            onClick={() => {
                              dataList[index].mandatory = !mandatory;
                              this.updateState({ dataList });
                            }}
                          />
                        </div>
                      </td>
                      <td
                        className={
                          tableHeader[3].enabled ?? true ? "" : "d-none"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={visible_in_registration}
                            onClick={() => {
                              dataList[index].visible_in_registration =
                                !visible_in_registration;
                              this.updateState({ dataList });
                            }}
                          />
                        </div>
                      </td>
                      <td
                        className={
                          tableHeader[3].enabled ?? true ? "" : "d-none"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={visible_in_profile}
                            onClick={() => {
                              dataList[index].visible_in_profile =
                                !visible_in_profile;
                              this.updateState({ dataList });
                            }}
                          />
                        </div>
                      </td>
                      <td
                        className={
                          tableHeader[3].enabled ?? true ? "" : "d-none"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={visible_in_listing}
                            onClick={() => {
                              dataList[index].visible_in_listing =
                                !visible_in_listing;
                              this.updateState({ dataList });
                            }}
                          />
                        </div>
                      </td>
                      <td
                        className={
                          tableHeader[3].enabled ?? true ? "" : "d-none"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={showLabel}
                            onClick={() => {
                              dataList[index].showLabel = !showLabel;
                              this.updateState({ dataList });
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : null}
            </TableWrapper>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dataList: state.customerPlus.customerPlusSettings,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCustomerPlusSettings,
      updateCustomerPlusSettings,
    },
    dispatch
  );
};

export const Settings = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(SettingsClass)
);
